import {ErrorPageEvent} from './error-page-event';

export class ErrorPageMissingEvent extends ErrorPageEvent {
}
